module.exports = __webpack_public_path__ + "img/Retail9.ac727135.png";